import { InjectionToken } from '@angular/core';
import type { FileUploadConfig } from '@pct-ng/feature-file-upload-native';

export const COVER_IMAGE_CONFIG_INJECTION_TOKEN = new InjectionToken<FileUploadConfig>(
  'cover-image-injection-config-token',
);
